import React, {createContext, ReactNode, useContext, useState} from "react";
import {TokenInterpace, UserInterface} from "./interface/UserInterface";
import {UserContextType} from "./init/UserInit";
import {readUserAccountDetailByTokenApi} from "../../api/account/AccountApi";
import {useMutation} from "@tanstack/react-query";
import i18n from "../../locales/i18n";
import useGoToNavigation from "../useGotoNavigation";

// 초기값을 UserInterface 타입으로 설정
const UserContext = createContext<UserContextType | undefined>(undefined);

interface UserProviderProps {
    children: ReactNode;
}

export const UserProvider: React.FC<UserProviderProps> = ({children}) => {
    const [user, setUser] = useState<UserInterface | null>(null); // 사용자 정보 상태
    const {goToNavigation} = useGoToNavigation();

    const readUserAccountDetailByTokenApiMutate = useMutation({
        mutationFn: readUserAccountDetailByTokenApi,
        onSuccess: (res) => {
            // console.log(res);
            if (res.data.code === "0000") {
                let lng = res.data.result.orgName === "Pacific" ? "en" : "ko"
                i18n.changeLanguage(lng).catch((err) => {
                    console.error("Language change failed", err);
                });
                const accessToken = localStorage.getItem("mdstech_accessToken");
                // base64 decode
                const base64Data = accessToken?.split(".")[1];
                const base64 = base64Data?.replace(/-/g, "+").replace(/_/g, "/");
                let jsonPayload = JSON.parse(atob(base64 || ""));
                jsonPayload.authority = JSON.parse(jsonPayload.authority);
                setUser({ ...jsonPayload, ...res.data.result});
            }
        },
        onError: (error) => {
            console.error(error);
            alert("사용자 정보를 가져오는 데 실패했습니다. 다시 로그인 해주세요.");
            localStorage.removeItem('mdstech_accessToken')
            goToNavigation('login', "", false)
        },
    });

    const login = (token: TokenInterpace) => {
        const accessToken = token.accessToken
        localStorage.setItem("mdstech_accessToken", accessToken);
        readUserAccountDetailByTokenApiMutate.mutate(); // 사용자 정보 요청
    };

    const logout = () => {
        localStorage.removeItem("mdstech_accessToken");
        setUser(null); // 사용자 정보 초기화
    };

    return (
        <UserContext.Provider value={{user, login, logout}}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = (): UserContextType => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("useUser must be used within a UserProvider");
    }
    return context;
};
